import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  reports: [],
  file: [],
  reportFile: {},
  reportPopupInfo: null,
  accountingFile: {},
  loading: false,
  error: null,
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    clearReportsError: (state) => {
      state.error = null;
    },
    setReportsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setReports: (state, action) => {
      const reports = action.payload;
      const processedReports = reports.map((report) => {
        if (
          Array.isArray(report?.generations) &&
          report?.generations?.length > 0
        ) {
          const latestGeneration = report?.generations.reduce(
            (latest, current) => {
              const currentDate = new Date(current.date);
              const latestDate = new Date(latest.date);
              return currentDate > latestDate ? current : latest;
            }
          );
          const result = {
            ...report,
            recentDate: latestGeneration?.date,
          };
          return result;
        } else {
          const result = {
            ...report,
            recentDate: report?.date,
          };
          return result;
        }
      });
      state.reports = processedReports;
    },
    setFile: (state, action) => {
      state.file = action.payload;
    },
    updateReport: (state, action) => {
      state.reportFile = action.payload;
      const generation = action.payload?.generation;
      const reportIndex = state?.reports?.findIndex(
        (a) => a?.reportId === action.payload?.report
      );
      if (reportIndex !== -1) {
        const report = state.reports[reportIndex];
        state.reportPopupInfo = {
          name: report.name,
          reportObject: report,
          generation: generation,
        };
      } else {
        state.reportPopupInfo = null;
      }
      if (reportIndex !== -1) {
        const updatedReports = [...state.reports];
        const report = updatedReports[reportIndex];
        if (report?.generations && Array.isArray(report?.generations)) {
          const existingGenerationIndex = report.generations.findIndex(
            (gen) =>
              gen?.date === generation?.date &&
              gen?.reportId === generation?.reportId
          );
          if (existingGenerationIndex !== -1) {
            report.generations[existingGenerationIndex] = {
              ...report.generations[existingGenerationIndex],
              ...generation,
            };
          } else {
            report.generations.push(generation);
          }
        } else {
          report.generations = [generation];
        }
        updatedReports[reportIndex] = report;
        state.reports = updatedReports;

        const reportName =
          report?.name?.charAt(0)?.toUpperCase() + report?.name?.slice(1);

        // Check if the response indicates failure
        if (action.payload?.failed === true) {
          // Update the generation stage to 3 (Failed)
          if (report?.generations && Array.isArray(report?.generations)) {
            const existingGenerationIndex = report.generations.findIndex(
              (gen) =>
                gen?.date === generation?.date &&
                gen?.reportId === generation?.reportId
            );
            if (existingGenerationIndex !== -1) {
              report.generations[existingGenerationIndex] = {
                ...report.generations[existingGenerationIndex],
                stage: 3,
              };
            }
          }
          toast.error(`${reportName} Report Generation Failed`);
        } else if (generation?.stage === 0) {
          toast.success(`${reportName} Report Generated`);
        } else if (generation?.stage === 2) {
          toast.success(`${reportName} Report Generation Initiated`);
        }
      } else {
        toast.error("Failed to generate report: Report not found");
      }
    },
    clearReportPopup: (state) => {
      state.reportPopupInfo = null;
    },
    clearReport: (state) => {
      state.reportFile = {};
    },
    addReport: (state, action) => {
      if (action.payload?.message && action.payload?.error) {
        toast.error(action.payload?.error);
        return;
      }

      const report = action.payload?.report;
      if (report) {
        const reportIndex = state?.reports?.findIndex(
          (a) => a?.reportId === report?.reportId
        );

        if (reportIndex === -1) {
          state.reports.push(report);
          const reportName =
            report?.name?.charAt(0)?.toUpperCase() + report?.name?.slice(1);

          toast.success(`${reportName} Report is Created`);
        } else {
          state.reports[reportIndex] = report;
        }
      }
    },
    setTradeCustodianAccountingFile: (state, action) => {
      state.accountingFile = action.payload;
    },
  },
});

export const { 
  clearReportsError, 
  setReportsLoading,
  setReports,
  setFile,
  updateReport,
  clearReportPopup,
  clearReport,
  addReport,
  setTradeCustodianAccountingFile
} = reportsSlice.actions;
export default reportsSlice.reducer;

// Selectors
export const selectReports = (state) => state.reports.reports;
export const selectFile = (state) => state.reports.file;
export const selectReportFile = (state) => state.reports.reportFile;
export const selectReportPopupInfo = (state) => state.reports.reportPopupInfo;
export const selectAccountingFile = (state) => state.reports.accountingFile;
export const selectReportsLoading = (state) => state.reports.loading;
export const selectReportsError = (state) => state.reports.error;
